import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class TicketButtonComponent {
  @Input() disabled = false;
  @Input() action: 'increase' | 'decrease' = 'increase';

  @Output() clicked = new EventEmitter<void>();

  constructor(private translateService: TranslateService) { }

  get icon(): string {
    return this.action === 'increase' ? 'fa-plus' : 'fa-minus';
  }

  get ariaLabel(): string {
    return this.action === 'increase'
      ? this.translateService.instant('web.increase')
      : this.translateService.instant('web.decrease');
  }

  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}